<template>
  <v-card flat class="ma-0 pa-0">
    <v-parallax class="hero-image" height="400" src="@/assets/images/start-hero.jpg">
      <v-card-title class="display-2 mb-1">{{ $t('start.title') }}</v-card-title>
    </v-parallax>
    <v-card-text>
      <v-row>
        <v-col cols="12">
          <div class="mx-8 mt-4 home-content" v-html="startContent"></div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: 'LoggedOutStart',

  data: () => ({
    contentLocale: ''
  }),

  computed: {
    ...mapGetters('app', ['startContent', 'locale'])
  },

  mounted() {
    if (!this.startContent || this.locale!==this.contentLocale) {
      this.$store.dispatch('app/loadStartContent', this.locale)
      this.contentLocale = this.locale
    }
  },

  watch: {
    locale() {
      this.$store.dispatch('app/loadStartContent', this.locale)
      this.contentLocale = this.locale
    }
  }

}
</script>

<style>

</style>